import { Portal } from "@ariakit/react";
import { UserPlus } from "@phosphor-icons/react";
import { Button } from "@replicate/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { queryClient } from "../query";
import { InviteToOrganizationDialog } from "./invite-to-organization-dialog";

export default function Invite({
  organizationName,
}: {
  organizationName: string;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <Portal>
        <Toaster />
      </Portal>
      <InviteToOrganizationDialog
        organizationName={organizationName}
        disclosure={
          <Button startIcon={<UserPlus weight="bold" />}>
            Invite to organization
          </Button>
        }
      />
    </QueryClientProvider>
  );
}
